export default __webpack_public_path__ + "f7caa37366814d8f9b988cb72861f996.woff";